import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import {Subject} from "rxjs";
import {RepairCentreDto} from "../../../auto-generated-server-dtos/repair-centre-information/models/repair-centre-dto";
import {TaxInformationDto} from "../../../auto-generated-server-dtos/claim/controllers/tax-information-dto";

@Component({
  selector: 'app-totals',
  templateUrl: './totals.component.html',
  styleUrls: ['./totals.component.scss']
})
export class TotalsComponent implements OnChanges {

  @Input() claimDto!: ClaimDto;
  @Input() repairTotal = 0;
  tax = 0;
  pst = 0;
  gst = 0;
  subTotal = 0;
  total = 0;
  @Input() manuallyEnteredDeductible!: number | null | undefined;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.repairTotal || changes.manuallyEnteredDeductible) {
      this.calculateTotals();
    }
  }

  setRepairTotal(total: number) {
    setTimeout(() => {
      this.repairTotal = total;
      this.calculateTotals();
    }, 0);
  }

  calculateTotals() {
    this.subTotal = this.repairTotal - (this.claimDto.manuallyEnteredDeductible ?? this.claimDto.warranty.deductible!);
    this.subTotal = this.subTotal < 0 ? 0 : this.subTotal;
    this.tax = this.subTotal * this.claimDto!.tax.rate;
    this.total = this.subTotal + this.tax;
  }
}
